<template>
    <modal
        modal-id="export-excel-modal"
        title="Export Excel"
        submit-button-text="Export"
        @submit="submit"
        @close-modal="$emit('close-modal')"
    >
        <template slot="body">

            <div class="form-group">
                <label>From Date</label>

                <input
                    type="date"
                    class="form-control"
                    v-model="form.start_date"
                >
            </div>

            <div class="form-group">
                <label>To Date</label>

                <input
                    type="date"
                    class="form-control"
                    v-model="form.end_date"
                >
            </div>

        </template>
    </modal>
</template>

<script>
export default {
    name: "ExportExcelModal",

    data() {
        return {
            form: {
                start_date: "",
                end_date: ""
            }
        }
    },

    methods: {

        submit() {

            if (!this.form.start_date || !this.form.end_date) {
                this.$toastr.e("Pilih range tanggal");
                return;
            }

            this.$emit("export", this.form);
        }

    }

}
</script>